import React from 'react'
import {connect} from 'react-redux'
import {withSiteData} from 'react-static'
import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap';

import {updateClient} from '../actions/clients'
import ClientForm from '../components/ClientForm'

class ShowClientModal extends React.Component {
  constructor(props){
    super(props)
    this.state = {show: true}
  }

  close = () => this.setState({show: false})

  restoreUrl = () => {
    this.props.history.replace(this.props.backPath || '/clients')
  }

  handleSubmit = (values) => this.props.submit(values).then(this.close)

  render() {
    return(
      <Modal
        size='lg'
        isOpen={this.state.show}
        toggle={this.close}
        onClosed={this.restoreUrl}>
        <ModalHeader toggle={this.props.close}>Kunden bearbeiten</ModalHeader>

        <ClientForm
          client={this.props.client}
          submit={this.handleSubmit}
          bodyComponent={ModalBody}
          buttonsComponent={({children}) =>
            <ModalFooter>
              {children}
              <Button color="secondary" onClick={this.close}>Abbrechen</Button>
            </ModalFooter>
          }/>
      </Modal>
    )
  }
}
export default connect(
  (state,ownProps) => {
    const client = state.clients.items.find(c => c.id===ownProps.match.params.id)
    return {
      client,
      isFetching: !client
    }
  },
  dispatch => ({
    submit: (payload) => dispatch(updateClient(payload))
  })
)(withSiteData(ShowClientModal))



// WEBPACK FOOTER //
// /Users/d064310/Development/playland/colorribbon/src/containers/ShowClient.js